import { render } from "./AddExpense.vue?vue&type=template&id=15fc478a&ts=true"
import script from "./AddExpense.vue?vue&type=script&lang=ts"
export * from "./AddExpense.vue?vue&type=script&lang=ts"

import "./AddExpense.vue?vue&type=style&index=0&id=15fc478a&lang=scss"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__